import React from "react";
import ReactDom from "react-dom";

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import BaseViewStore from 'base-viewstore';

export class StaticViewStore extends BaseViewStore {

    // validation is a derivation
    @computed get invalid() {
        const invalid = {};
        return invalid;
    }  

    @action.bound save() {
    }
}


export class StaticTextViewStore extends StaticViewStore {
}

export class StaticImageViewStore extends StaticViewStore {
}



// WEBPACK FOOTER //
// ./app_modules/form-control-activity/static/viewstore.js